export default "__VITE_ASSET__DOs1YHeG__"